import { useMaskInput } from "hooks/useMaskInput";
import { useState } from "react";
import { ContainerInput, InputComponent } from "./style";

interface IProps {
  valor: string;
  idDescricao: number;
  atualizarValor: (idDescricao: number, valor: string) => void;
}
export function InputValor({ valor, idDescricao, atualizarValor }: IProps) {
  const [valorEscolhido, setValorEscolhido] = useState<string>(valor);
  const { mInputCoin } = useMaskInput();

  return (
    <ContainerInput>
      <InputComponent
        type="text"
        value={valorEscolhido}
        onChange={(e: any) => {
          const rawValue = e.target.value.replace(/[^0-9.]/g, "");
          const masked = mInputCoin({
            ...e,
            target: { ...e.target, value: rawValue },
          });

          setValorEscolhido(masked);
          atualizarValor(idDescricao, masked);
        }}
      />
    </ContainerInput>
  );
}
